import { IS_USE_CENTIMETERS_SIZE_COUNTRY } from '@/constants/is-use-centimeters-size-country';
import { sizeMap } from '@/constants/size-map';
import { websiteEnv } from '@/constants/website-env';
import useIsMobile from '@/hooks/use-is-mobile';
import { gql, useLazyQuery } from '@apollo/client';
import clsx from 'clsx';
import { useEffect, useMemo, useRef, useState } from 'react';
import LoadingIndicator from '../LoadingIndicator';
const SizeChart = props => {
  const { showAttribute, sizechartdialog } = props;

  const sizeChartValue = showAttribute?.find(item => item.code === 'product_size_chart')?.value;
  const divListRef = useRef([]);
  const isMobile = useIsMobile();
  const blockName = useMemo(() => sizeChartValue?.split(', '), [sizeChartValue]);
  const [loading, setLoading] = useState(false);
  const [reqCmsBlocks] = useLazyQuery(
    gql`
      query cmsBlocks($identifiers: [String]!) {
        cmsBlocks(identifiers: $identifiers) {
          items {
            content
            identifier
          }
        }
      }
    `,
    { fetchPolicy: 'cache-and-network' },
  );

  useEffect(() => {
    if (!Array.isArray(blockName) || blockName.length === 0) {
      return;
    }

    setLoading(true);
    blockName.forEach((identifiers, i) => {
      reqCmsBlocks({ variables: { identifiers } })
        .then(({ data }) => {
          const blockContent = data?.cmsBlocks?.items?.[0]?.content;
          const container = divListRef.current[i];

          if (!blockContent || !container) return;

          const content =
            blockContent.indexOf('sizechartpartition') > -1
              ? sizechartdialog
                ? escape2Html(decodeURI(blockContent.replace(/%/g, '%25')).split('sizechartpartition')[1])
                : escape2Html(decodeURI(blockContent.replace(/%/g, '%25')).split('sizechartpartition')[0])
              : escape2Html(blockContent);

          container.innerHTML = content;

          const table = container.querySelector('table');
          const trs = table?.querySelectorAll('tr');
          const tds = trs?.[0]?.querySelectorAll('td');

          Array.from(tds).forEach(td => {
            if (
              websiteEnv.isUnitedKingdom ||
              websiteEnv.isAustralia ||
              websiteEnv.isIreland ||
              websiteEnv.isNewZealand ||
              websiteEnv.isGermanyEnglish
            ) {
              td.textContent = sizeMap[td.textContent] || td.textContent;
            }
          });

          if (IS_USE_CENTIMETERS_SIZE_COUNTRY) {
            Array.from(trs).forEach((row, index) => {
              if (index === 0) {
                return;
              }
              const tds = row.querySelectorAll('td');

              Array.from(tds).forEach((td, index) => {
                if (index === 0) return;

                let sizeNumber = td.textContent;
                sizeNumber = sizeNumber.replaceAll('½', '.5').replaceAll('¼', '.25').replaceAll('¾', '.75');
                sizeNumber = parseFloat(sizeNumber);
                sizeNumber = (sizeNumber * 2.54).toFixed(1);
                td.textContent = `${sizeNumber}cm`;
              });
            });
          }

          if (sizechartdialog && isMobile) {
            transformTable(table);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    });
  }, [reqCmsBlocks, blockName, sizechartdialog, isMobile]);

  if (!Array.isArray(blockName)) return null;

  return (
    <>
      {blockName.map((x, i) => {
        return (
          <div
            className={clsx(
              '[&_.sizetabcon]_w-full',
              'text-center text-[15px]',
              '[&_.sizetabcon_thead]_bg-f8f3ef',
              '[&_.sizetabcon_td]_py-[5px]',
              '[&_.sizetabcon_tr:first-child_td]_py-2.5',
              'lg_[&_.sizetabcon_tr:first-child_td]_py-[5px]',
              '[&_.sizetabcon_td]_border-solid',
              '[&_.sizetabcon_td]_border-1',
              '[&_.sizetabcon.showpc_td]_border-E7DED5',
              'lg_[&_.sizetabcon_td:first-child]_bg-f8f3ef',
              '[&_.sizetabcon_tr:first-child_td]_bg-f8f3ef',
              'lg_[&_.sizetabcon_tr:first-child_td]_bg-transparent',
              'lg_[&_.sizetabcon_tr:first-child_td:first-child]_bg-f8f3ef',
            )}
            ref={node => {
              divListRef.current[i] = node || null;
            }}
            key={i}
          />
        );
      })}
      {loading && <LoadingIndicator />}
    </>
  );
};

function escape2Html(str) {
  const arrEntities = {
    lt: '<',
    gt: '>',
    nbsp: ' ',
    amp: '&',
    quot: '"',
  };

  return str?.replace(/&(lt|gt|nbsp|amp|quot);/gi, function (all, t) {
    return arrEntities[t];
  });
}

const transformTable = table => {
  const trsArr = Array.from(table.querySelectorAll('tr'));
  const colCount = trsArr[0]?.querySelectorAll('td').length || 0;
  let matrix = [];

  if (!colCount) return;

  for (const tr of trsArr) {
    const tdContentArr = [];
    const tds = tr.querySelectorAll('td');

    tds.forEach(x => {
      tdContentArr.push(x.textContent);
    });
    matrix.push(tdContentArr);
  }

  matrix = matrix[0].map((col, i) => matrix.map(row => row[i]));

  const tbody = table.querySelector('tbody');

  if (!tbody) return;

  while (tbody.firstChild) {
    tbody.removeChild(tbody.firstChild);
  }

  for (const row of matrix) {
    const tRow = document.createElement('tr');
    const colCount = row.length;

    for (const cellContent of row) {
      const tCell = document.createElement('td');
      tCell.textContent = cellContent;
      tCell.style.width = `${(100 / colCount).toFixed(2)}%`;
      tRow.appendChild(tCell);
    }

    tbody.appendChild(tRow);
  }
};

export default SizeChart;
